/* eslint-disable */
import { Row, Col } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

import { Button, CardContent, Modal, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

import MainCard from 'components/MainCard';
import { getEquipmentStatusesByQuery } from 'components/axios/equipmentAxios';

import { useEnumApi } from 'contexts/EnumApiContext';
import EquipmentStatusExcelDownload from 'components/EquipmentStatusExcelDownload';

const EquipmentStatusLayer = ({info}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => setOpen(false);

    const separate = "___";
    const printRef = useRef(null);

    // const [isLoading, setIsLoading] = useState(false);
    const [equipmentStatuses, setEquipmentStatuses] = useState(null);
    
    const [excelDatas1, setExcelDatas1] = useState([]);
    const [excelDatas2, setExcelDatas2] = useState([]);
    const [excelDatas3, setExcelDatas3] = useState([]);
    const [fileName, setFileName] = useState("");

    useEffect(()=>{
        if (info) {
            equipmentStatusesList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    // 설비현황기준관리 목록
    const equipmentStatusesList = async () => {
        Promise.all([
            // 설비 현황
            getEquipmentStatusesByQuery({ "equipment.id": info.id, size:50}).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentStatuses;
                    if (list) {
                        //console.log(list[0]);
                        setEquipmentStatuses(list[0]);
                        return list[0];
                    }
                }
                setEquipmentStatuses(null);
                return null;
            })
        ]).then((res)=>{
          const statuss = res[0];
          // console.log(statuss);
          if (statuss != null) {
            setFileName(info?.name+"_"+t('message.common.file.name.status.table')+"_" + Date.now());
            
            setExcelDatas1([t('message.common.subtitle.fieldChkUser'), statuss.chkUser, '', t('message.common.subtitle.inspection.date'), (statuss.chkYmd || '')
              , t('message.common.subtitle.installation.location')+'(No.)', statuss?.equipment?.location, '']);
            // console.log(excelDatas1);

            let excelDatas2 = [];
            if (statuss.basicItems != null && statuss.basicItems.length > 0) {
              let excelData2 = [];
              statuss.basicItems.map((bItem, i)=>{
                excelData2 = [];
                excelData2.push(bItem.itemNm);
                excelData2.push('');
                excelData2.push('');
                excelData2.push(bItem.value);
                excelDatas2.push(excelData2);
              })
            }
            // console.log(excelDatas2);
            setExcelDatas2(excelDatas2);

            let excelDatas3 = [[t('message.common.subtitle.item'),'','', t('message.common.subtitle.unit'), t('message.common.subtitle.design.value'), '', t('message.common.subtitle.remark'), '']];
            if (statuss.statusItems != null && statuss.statusItems.length > 0) {
              let excelData3 = [];
              let itemName ;
              statuss.statusItems.map((sItem, i)=>{
                excelData3 = [];
                itemName = sItem.itemNm ? sItem.itemNm.split(separate) : "_________".split(separate);

                if (itemName[0] != '' && itemName[1] != '') {
                  excelData3.push({col:1,value:itemName[0]});
                  excelData3.push({col:1,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] != '' && itemName[1] == '') {
                  excelData3.push({col:2,value:itemName[0]});
                  excelData3.push({col:0,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] == '' && itemName[1] != '') {
                  excelData3.push({col:0,value:itemName[0]});
                  excelData3.push({col:2,value:itemName[1]});
                  excelData3.push({col:1,value:itemName[2]});
                } else if (itemName[0] == '' && itemName[1] == '') {
                  excelData3.push({col:0,value:itemName[0]});
                  excelData3.push({col:0,value:itemName[1]});
                  excelData3.push({col:3,value:itemName[2]});
                }

                excelData3.push(sItem.unit);
                excelData3.push(sItem.value);
                excelData3.push('');
                excelData3.push('');
                excelData3.push('');
                excelDatas3.push(excelData3);
              })
            }
            setExcelDatas3(excelDatas3);
          }
        })
    };

    return (
      <>
        <button
            className='pop_style_btn'
            style={{
              height: "28px",
              minHeight: "28px"
            }}
            type="button"
            data-ledger-asset={info?.equipmentNo ?? info?.id}
            onClick={handleOpen}
          >
            <span>{t('message.common.file.name.status.table')}</span>

            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
              style={{
                display: "block",
                flexShrink: 0
              }}
            >
              <path d="M7 17 17 7M8 7h9v9" />
            </svg>
          </button>

        <Modal className="pop_box pop_box4 equipment_status_renew_pop" open={open} onClose={handleClose} aria-labelledby="equipment-status-modal-title" aria-describedby="equipment-status-modal-description">
          <MainCard title="" modal darkTitle content={false} style={{width:"800px", maxWidth:"calc(100vw - 40px)"}}>
            <div className="equipment_status_modal_header">
              <div className="equipment_status_modal_heading" id="equipment-status-modal-title">
                <span aria-hidden="true">📋</span>
                <span>{t('message.common.file.name.status.table')}</span>
              </div>
              <Button variant="contained" className="equipment_status_close_btn" size="small" onClick={handleClose}>
                {t('message.common.btn.close')}
              </Button>
            </div>
            <CardContent className="equipment_status_modal_content">
            <MainCard className="center_table equipment_status_document" content={false} ref={printRef}>
              <div className="equipment_status_equipment_caption" id="equipment-status-modal-description">
                <span className="equipment_status_equipment_name">{info?.name}</span>
                <span className="equipment_status_equipment_no">{info?.equipmentNo}</span>
              </div>
              {equipmentStatuses && 
                  <TableContainer>
                  <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width pop_sh0">
                    <TableBody>
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.fieldChkUser')}</TableCell>
                        <TableCell align="center">{equipmentStatuses.chkUser || ''}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.inspection.date')}</TableCell>
                        <TableCell align="center">{equipmentStatuses.chkYmd}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')}</TableCell>
                        <TableCell align="center" style={{wordBreak: "keep-all"}}>{equipmentStatuses.equipment && (equipmentStatuses.equipment.location || '')}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer> 
              }

              <TableContainer>
                <Table style={{marginTop:"10px"}} sx={{ minWidth: 400 }} aria-label="simple table" className="same_width pop_sh">
                <TableBody>
                  {equipmentStatuses && equipmentStatuses.basicItems && equipmentStatuses.basicItems.map(function(item, i) {
                      return (
                  <TableRow key={i} className='pop_tr'>
                      <TableCell className="th" align="center" colSpan="2">{item.itemNm}</TableCell>
                      <TableCell colSpan="2">{item.value || ''}</TableCell>
                  </TableRow>
                      )
                  }) }
                  <TableRow>
                      <TableCell className="th" align="center" colSpan="2" style={{width:"190px"}}>{t('message.common.subtitle.item')}</TableCell>
                      <TableCell className="th" align="center" style={{width:"90px"}}>{t('message.common.subtitle.unit')}</TableCell>
                      <TableCell className="th" align="center" style={{width:"170px"}}>{t('message.common.subtitle.design.value')}</TableCell>
                  </TableRow>
                  { equipmentStatuses && equipmentStatuses.statusItems && equipmentStatuses.statusItems.map(function(item2, i) {
                  // console.log(item2);
                      let itemName = item2.itemNm ? item2.itemNm.split(separate) : "_________".split(separate);
                      return (
                  <TableRow key={i} className='pop_tr'>
                      {(itemName[0] || itemName[1]) && 
                      <>
                      <TableCell align="center">{itemName[0]}{itemName[1] && (' | '+itemName[1])}</TableCell>
                      <TableCell align="center">{itemName[2]}</TableCell>
                      </>
                      }
                      {!(itemName[0] || itemName[1]) && 
                      <>
                      <TableCell colSpan="2" align="center">{itemName[2]}</TableCell>
                      </>
                      }
                      <TableCell align="center">{item2.unit}</TableCell>
                      <TableCell align="center">{item2.value || ''}</TableCell>
                  </TableRow>
                      )
                  }) }
                  </TableBody>
                </Table>
              </TableContainer>
              {(excelDatas2.length > 0 || excelDatas3.length > 0) &&
              <div className="equipment_status_download_actions">
                <EquipmentStatusExcelDownload excelDatas1={excelDatas1} excelDatas2={excelDatas2} excelDatas3={excelDatas3} title={`${info?.name} ${t('message.common.file.name.status.table')}`} filename={`${fileName}.xlsx`} />
              </div>
              }
            </MainCard>
            </CardContent>
          </MainCard>
        </Modal>
      </>
    )
    //}
}

export default EquipmentStatusLayer;